import { PublicInterceptor } from "../../../Base/interceptors/PublicInterceptor";

export const getVisitasDate = async(fechas, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/listado`, 'POST', fechas, token)
    return result;
}

export const getVisitaDetalle = async(NoVisita, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/detalles/${NoVisita}`, 'GET',null, token)
    return result;
}

// OBTENER UNA VISITA POR ID
export const getVisitaByNoVisita = async(NoVisita, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/NoVisita/${NoVisita}`, 'GET', null, token)
    return result;
}

export const getPublicVisitaByNoVisita = async(NoVisita) => {
    const result = await PublicInterceptor(`Logistica/Visitas/Public/${NoVisita}`, 'GET')
    return result;
}

// OBTENER TIPOS DE VISITAS
export const getVisitaTipos = async(token) => {
    // console.log(token);
    const result = await PublicInterceptor(`Logistica/Visitas/tiposVisita`, 'GET', null, token)
    return result;
}

// GUARDAR VISITA
export const saveVisita = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas`, 'POST', data, token)
    return result;
}

// ACTUALIZAR VISITA
export const updateVisita = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas`, 'PUT', data, token)
    return result;
}

// CANCELAR VISITA
export const cancelVisita = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/CancelarVisita`, 'DELETE', data, token)
    return result;
}

// CANCELAR VISITA DETALLE
export const cancelVisitaDetalle = async(data, token) => {
    const result = await PublicInterceptor(`Logistica/Visitas/CancelarVisitantes`, 'DELETE', data, token)
    return result;
}